export default [
  {
    title: '布局字段',
    // disabled: true,
    list: [{
      type: 'group',
      label: '分组',
      icon: 'icon-group',
      display: true,
      arrow: false,
      collapse: true,
      children: {
        column: []
      }
    }]
  },
  {
    title: '输入字段',
    list: [
      {
        type: 'input',
        label: '单行文本',
        icon: 'icon-input',
        span: 12,
        maxlength: 60,
        display: true,
        shieldProcessRecord: true
      },
      {
        type: 'password',
        label: '密码',
        icon: 'icon-password',
        span: 12,
        maxlength: 60,
        display: true,
        shieldProcessRecord: true
      },
      {
        type: 'textarea',
        label: '多行文本',
        icon: 'icon-textarea',
        span: 24,
        maxlength: 1000,
        display: true,
        shieldProcessRecord: true
      },
      {
        type: 'number',
        label: '计数器',
        icon: 'icon-number',
        span: 12,
        display: true,
        shieldProcessRecord: true
      },
      // {
      //   type: 'url',
      //   label: '超链接', // 场景 ？？
      //   icon: 'icon-url',
      //   span: 24,
      //   display: true
      // },
      {
        type: 'dynamic',
        component: 'dynamicForm2',
        label: '子表单',
        icon: 'icon-table',
        span: 24,
        display: true,
        children: {
          align: 'center',
          headerAlign: 'center',
          column: [
            {
              'type': 'input',
              'label': '子表主键',
              'span': 24,
              'display': false,
              'hide': true,
              'prop': 'id'
            },
            {
              'type': 'input',
              'label': '主表关联字段',
              'span': 24,
              'display': false,
              'hide': true,
              'prop': 'pid',
              'readonly': false
            }
          ]
        },
        columnBtn: false,
        menuWidth: 150
      },
      {
        type: 'divider',
        component: 'divider',
        label: '分割线',
        icon: 'icon-slider',
        display: true,
        span: 24,
        color: 'rgba(0, 0, 0, 1)',
        dalign: 'left',
        labelWidth: 0,
        dividerlevel: 2
      }
      /*
      {
        type: 'general',
        label: '通用行',
        icon: 'icon-input',
        span: 24,
        display: true
      }*/
    ]
  },
  {
    title: '选择字段',
    list: [
      {
        type: 'radio',
        dicOption: '1',
        dicUrl: '',
        label: '单选框组',
        icon: 'icon-radio',
        dicData: [
          { label: '选项一', value: '0' },
          { label: '选项二', value: '1' },
          { label: '选项三', value: '2' }
        ],
        span: 24,
        display: true,
        props: {},
        shieldProcessRecord: true
      },
      {
        type: 'checkbox',
        label: '多选框组',
        dicOption: '1',
        icon: 'icon-checkbox',
        dicData: [
          { label: '选项一', value: '0' },
          { label: '选项二', value: '1' },
          { label: '选项三', value: '2' }
        ],
        span: 12,
        display: true,
        props: {},
        shieldProcessRecord: true
      },
      {
        type: 'select',
        label: '下拉选择器',
        icon: 'icon-select',
        dicOption: '1',
        dicUrl: '',
        cascaderItem: [],
        localDic: [],
        dicFlag: true,
        dicData: [
          { label: '选项一', value: '0' },
          { label: '选项二', value: '1' },
          { label: '选项三', value: '2' }
        ],
        span: 12,
        display: true,
        props: {},
        dynamicHide: [],
        shieldProcessRecord: true
      },
      {
        type: 'cascader',
        dicOption: '1',
        dicUrl: '',
        label: '级联选择器',
        icon: 'icon-link',
        span: 12,
        display: true,
        dicData: [
          {
            label: '选项一',
            value: '0',
            children: [
              {
                label: '选项1-1',
                value: '11'
              },
              {
                label: '选项1-2',
                value: '12'
              }
            ]
          },
          { label: '选项二', value: '1' },
          { label: '选项三', value: '2' }
        ],
        showAllLevels: true,
        separator: '/',
        props: {},
        shieldProcessRecord: true
      },
      {
        type: 'tree',
        label: '树形选择器',
        dicOption: '1',
        dicUrl: '',
        icon: 'icon-tree',
        span: 12,
        display: true,
        dicData: [
          {
            label: '选项一',
            value: '0',
            children: [
              {
                label: '选项1-1',
                value: '11'
              },
              {
                label: '选项1-2',
                value: '12'
              }
            ]
          },
          { label: '选项二', value: '1' },
          { label: '选项三', value: '2' }
        ],
        props: {},
        shieldProcessRecord: true
      },
      {
        type: 'flowUserChoose',
        component: 'flow-user-choose',
        label: '用户选择器',
        icon: 'icon-choose',
        span: 12,
        display: true,
        placeholder: '请选择用户',
        maxRows: 1,
        disabled: false,
        endPlaceholder: '',
        idListName: '',
        nameListName: '',
        shieldProcessRecord: true
      },
      {
        type: 'popUpWindow',
        component: 'pop-up-window',
        label: '弹框选择器',
        icon: 'icon-choose',
        span: 12,
        display: true,
        placeholder: '请选择',
        maxRows: 1,
        disabled: false,
        endPlaceholder: '',
        shieldProcessRecord: true
        // idListName: '',
        // nameListName: ''
      }
    ]
  }, /*,  {
    title: '上传字段',
    list: [
      {
        type: 'upload',
        label: '上传',
        icon: 'icon-upload',
        span: 24,
        display: true,
        showFileList: true,
        multiple: true,
        limit: 10,
        props: {},
        headers: {},
        propsHttp: {},
        canvasOption: {},
        fileNames: []
      }
    ]
  }*/
  {
    title: '日期时间字段',
    list: [
      {
        type: 'year',
        label: '年',
        icon: 'icon-year',
        span: 12,
        display: true,
        format: 'yyyy',
        valueFormat: 'yyyy',
        shieldProcessRecord: true
      },
      {
        type: 'month',
        label: '月',
        icon: 'icon-month',
        span: 12,
        display: true,
        format: 'yyyy-MM',
        valueFormat: 'yyyy-MM',
        shieldProcessRecord: true
      },
      {
        type: 'week',
        label: '周',
        icon: 'icon-week',
        span: 12,
        display: true,
        format: 'yyyy 第 WW 周',
        valueFormat: 'yyyy-MM-dd',
        shieldProcessRecord: true
      },
      {
        type: 'date',
        label: '日期',
        icon: 'icon-date',
        span: 12,
        display: true,
        format: 'yyyy-MM-dd',
        valueFormat: 'yyyy-MM-dd',
        shieldProcessRecord: true
      },
      {
        type: 'time',
        label: '时间',
        icon: 'icon-time',
        span: 12,
        display: true,
        format: 'HH:mm',
        valueFormat: 'HH:mm',
        start: '09:00',
        step: '00:30',
        end: '18:00',
        mode: '2',
        shieldProcessRecord: true
      },
      {
        type: 'datetime',
        label: '日期时间',
        icon: 'icon-datetime',
        span: 12,
        display: true,
        format: 'yyyy-MM-dd HH:mm',
        valueFormat: 'yyyy-MM-dd HH:mm',
        shieldProcessRecord: true
      },
      {
        type: 'daterange',
        label: '日期范围',
        icon: 'icon-date-range',
        span: 12,
        display: true,
        format: 'yyyy-MM-dd',
        valueFormat: 'yyyy-MM-dd',
        shieldProcessRecord: true
      },
      {
        type: 'timerange',
        label: '时间范围',
        icon: 'icon-time-range',
        span: 12,
        display: true,
        format: 'HH:mm',
        valueFormat: 'HH:mm',
        shieldProcessRecord: true
      },
      {
        type: 'datetimerange',
        label: '日期时间范围',
        icon: 'icon-datetime-range',
        span: 12,
        display: true,
        format: 'yyyy-MM-dd HH:mm',
        valueFormat: 'yyyy-MM-dd HH:mm',
        shieldProcessRecord: true
      }
    ]
  },
  {
    title: '其他字段',
    list: [
      {
        type: 'ueditor',
        component: 'avue-ueditor',
        label: '富文本',
        icon: 'icon-richtext',
        span: 24,
        display: true,
        options: {
          // action: '/common/document/upload',
          uploadImgShowBase64: true
        }
      },
      {
        type: 'upload',
        label: '上传',
        icon: 'icon-upload',
        span: 24,
        display: true,
        showFileList: true,
        multiple: true,
        limit: 10,
        props: {},
        headers: {},
        propsHttp: {},
        canvasOption: {},
        fileNames: []
      },
      {
        type: 'hyperLink',
        component: 'hyper-link',
        label: '超链接',
        title: '超链接',
        icon: 'icon-url',
        targetType: '_blank',
        span: 24,
        display: true,
        maxRows: 1,
        disabled: false,
        width: '80%',
        height: '80%'
      },
      {
        type: 'caption',
        component: 'caption-ext',
        label: '说明文字',
        icon: 'icon-url',
        span: 24,
        display: true,
        disabled: false,
        backgroundColor: 'rgba(246, 246, 246, 100)',
        fontSize: '14px',
        lineHeight: '22px'
      },
      {
        type: 'calculateFormula',
        component: 'calculator',
        label: '计算公式',
        formulaType: 'number',
        icon: 'icon-cpu',
        span: 12,
        display: true,
        shieldProcessRecord: true
      },
      {
        type: 'position',
        component: 'dingPosition',
        label: '地图定位',
        icon: 'icon-position',
        span: 12,
        display: true,
        addressType: 'address',
        shieldProcessRecord: true
      },
      {
        type: 'area',
        component: 'dingArea',
        label: '地图范围',
        icon: 'icon-area',
        span: 12,
        display: true,
        addressType: 'address',
        verifyType: 'force',
        shieldProcessRecord: true
      },
      {
        type: 'webMap',
        component: 'web-map',
        label: '地图选择器',
        icon: 'icon-map',
        span: 12,
        display: true,
        shieldProcessRecord: true
      },
      {
        type: 'qrcode',
        component: 'qrcode',
        label: '二维码',
        icon: 'qr-code',
        span: 24,
        labelPosition: 'top',
        display: true,
        url: '',
        logoImg: '',
        tip: '',
        qrurl: '',
        remote: false,
        rate: '30'
      },
      {
        type: 'signature',
        component: 'signature',
        label: '签名',
        icon: 'icon-checkbox',
        span: 12,
        display: true
        // excelRow1: null,
        // excelCol1: null,
        // excelRow2: null,
        // excelCol2: null,
        // pdfPaddingLeft: null,
        // pdfPaddingBottom: null,
        // pdfImgWidth: null,
        // pdfImgHeight: null
      },
      {
        type: 'licensePlate',
        component: 'license-plate',
        label: '车牌选择器',
        icon: 'icon-input',
        span: 12,
        display: true,
        maxlength: 20,
        shieldProcessRecord: true
      },
      {
        type: 'templateFile',
        component: 'template-file',
        label: '套红组件',
        icon: 'icon-slider',
        span: 24,
        display: true
      },
      {
        type: 'upload',
        component: 'file-online',
        label: 'office在线',
        icon: 'icon-upload',
        span: 24,
        display: true
      }
      // {
      //   type: 'office',
      //   component: 'office',
      //   label: 'office',
      //   icon: 'icon-input',
      //   // labelPosition: top,
      //   labelWidth: 0,
      //   span: 24,
      //   display: true,
      //   maxlength: 20,
      //   shieldProcessRecord: true
      // }
    ]
  } /*,
  {
    title: '其他字段',
    list: [
      {
        type: 'switch',
        label: '开关',
        icon: 'icon-switch',
        span: 12,
        display: true,
        valueDefault: 0,
        dicData: [
          { label: '', value: '0' },
          { label: '', value: '1' }
        ]
      },
      {
        type: 'rate',
        label: '评价',
        icon: 'icon-star',
        span: 12,
        display: true,
        max: 5,
        valueDefault: 0,
        texts: ['极差', '失望', '一般', '满意', '惊喜'],
        colors: ['#99A9BF', '#F7BA2A', '#FF9900']
      },
      {
        type: 'silder',
        label: '滑块',
        icon: 'icon-slider',
        span: 24,
        display: true,
        min: 0,
        max: 10
      },
      {
        type: 'color',
        label: '颜色选择器',
        icon: 'icon-color',
        span: 24,
        display: true
      }
    ]
  }*/
]
